import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { resolveAppUrl } from './is-vendor-portal-url';

export function appUrlChanges(router: Router) {
  return router.events.pipe(
    filter(
      (event): event is NavigationStart | NavigationEnd =>
        event instanceof NavigationStart || event instanceof NavigationEnd
    ),
    map(event =>
      event instanceof NavigationEnd ? event.urlAfterRedirects : event.url
    ),
    startWith(resolveAppUrl(router.url))
  );
}
